import { GlIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'SidebarConfidentialityContent',
    components: {
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        confidential: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'expand-sidebar'
    ],
    computed: {
        confidentialIcon () {
            return this.confidential ? 'eye-slash' : 'eye';
        },
        tooltipLabel () {
            return this.confidential ? __('Confidential') : __('Not confidential');
        }
    }
};
